module.exports = __webpack_public_path__ + "img/transport_TrainBooking.9adad5c.png";